/**
 * Offset pagination.
 *
 * Always shows the total and the range on screen, not just arrows. An operator
 * looking at a list needs to know whether they are seeing all of it — "1–25 of
 * 25" and "1–25 of 4,812" are the same screen otherwise, and one of them is
 * hiding almost everything.
 */
interface Props {
  total: number
  limit: number
  offset: number
  onOffset: (n: number) => void
  /** What is being counted, singular. "sample", "home", "decision". */
  noun: string
}

export default function Pager({ total, limit, offset, onOffset, noun }: Props) {
  if (total === 0) return null
  const from = offset + 1
  const to = Math.min(offset + limit, total)
  const page = Math.floor(offset / limit) + 1
  const pages = Math.max(1, Math.ceil(total / limit))

  return (
    <div className="pager">
      <span className="muted">
        {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
        {' '}{noun}{total === 1 ? '' : 's'}
      </span>
      <span style={{ flex: 1 }} />
      <button className="btn ghost sm" disabled={offset === 0}
              onClick={() => onOffset(0)}>First</button>
      <button className="btn ghost sm" disabled={offset === 0}
              onClick={() => onOffset(Math.max(0, offset - limit))}>Previous</button>
      <span className="muted" style={{ minWidth: '6.5rem', textAlign: 'center' }}>
        Page {page} of {pages.toLocaleString()}
      </span>
      <button className="btn ghost sm" disabled={to >= total}
              onClick={() => onOffset(offset + limit)}>Next</button>
      <button className="btn ghost sm" disabled={to >= total}
              onClick={() => onOffset((pages - 1) * limit)}>Last</button>
    </div>
  )
}
